const API_BASE = (import.meta.env.VITE_API_BASE_URL || "").replace(/\/$/, "");

function apiUrl(path: string): string {
  if (path.startsWith("http")) return path;
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE}${p}`;
}

function filenameFromDisposition(header: string | null): string | null {
  if (!header) return null;
  const star = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (star?.[1]) {
    try {
      return decodeURIComponent(star[1].trim());
    } catch {
      return star[1].trim();
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(header);
  return plain?.[1]?.trim() || null;
}

export type ProjectsCsvExportResult = {
  filename: string;
  savedPath: string | null;
};

/**
 * POST export, save server copy under output/, and trigger browser download.
 *
 * Projects the family pass marked DUPLICATION are left out unless `includeDuplicates`
 * (PDR Chapter 2: traceable, but excluded from the dataset).
 */
export async function downloadProjectsCsv(
  target = "",
  options: { includeDuplicates?: boolean } = {},
): Promise<ProjectsCsvExportResult> {
  const res = await fetch(apiUrl("/api/projects/export/csv"), {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ target: target.trim(), include_duplicates: Boolean(options.includeDuplicates) }),
  });
  if (!res.ok) {
    let message = res.statusText || "Export failed";
    try {
      const data = (await res.json()) as { error?: string; detail?: string };
      message = data.error || data.detail || message;
    } catch {
      /* binary / empty body */
    }
    throw new Error(message);
  }
  const blob = await res.blob();
  const filename =
    filenameFromDisposition(res.headers.get("Content-Disposition")) ||
    `orion1-projects-${new Date().toISOString().slice(0, 10)}.csv`;
  const savedPath = res.headers.get("X-Orion1-Saved-Path");

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);

  return { filename, savedPath };
}
